import React from 'react'

// Octagon frames are two nested clips — borders can't follow clip-path
const OCTAGON_OUTER_CLIP = 'polygon(14px 0,calc(100% - 14px) 0,100% 14px,100% calc(100% - 14px),calc(100% - 14px) 100%,14px 100%,0 calc(100% - 14px),0 14px)'
const OCTAGON_INNER_CLIP = 'polygon(13px 0,calc(100% - 13px) 0,100% 13px,100% calc(100% - 13px),calc(100% - 13px) 100%,13px 100%,0 calc(100% - 13px),0 13px)'

export default function Header() {
    return (
        <header className="print-avoid-break relative">
            <div className="relative pt-10 md:pt-16">
                <div className="flex flex-col items-center text-center md:flex-row md:items-center md:text-left gap-6 md:gap-10">
                    {/* Octagon portrait — gradient rim, the one decorative glow in the system */}
                    <div
                        className="flex-shrink-0 print-no-filter"
                        style={{filter: 'drop-shadow(0 0 16px rgba(99,102,241,.35))'}}
                    >
                        <div
                            className="p-[3px]"
                            style={{
                                background: 'linear-gradient(160deg,#0066FF,#6366f1 55%,#7c3aed)',
                                clipPath: OCTAGON_OUTER_CLIP,
                            }}
                        >
                            <div
                                className="print-portrait relative overflow-hidden bg-panel"
                                style={{clipPath: OCTAGON_INNER_CLIP}}
                            >
                                <img
                                    src="/me.png"
                                    alt="Yoaquim Cintron-Rosario"
                                    className="w-36 h-36 md:w-44 md:h-44 object-cover object-[center_15%]"
                                />
                                <span
                                    className="no-print pointer-events-none absolute inset-y-0 w-1/3 motion-safe:animate-nb-sheen"
                                    style={{background: 'linear-gradient(105deg,transparent,rgba(255,255,255,.35),transparent)'}}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        <p className="font-display font-bold text-[11px] uppercase tracking-[.3em] text-accent">
                            {'// CURRICULUM VITAE'}
                        </p>
                        <h1 className="font-display font-bold uppercase text-4xl md:text-6xl leading-none tracking-[.01em] bg-gradient-to-r from-primary via-accent-deep to-accent-violet bg-clip-text text-transparent pb-1">
                            Yoaquim<br />Cintron-Rosario
                        </h1>
                        <p className="font-display font-semibold uppercase tracking-[.12em] text-base md:text-lg text-accent">
                            Senior Engineering Leader<span className="text-faint"> — </span>AI Solutions Architect
                        </p>
                    </div>
                </div>

                <div className="mt-8 flex flex-wrap items-center justify-center md:justify-start gap-2.5 font-mono text-[11px] tracking-[.08em]">
                    <a
                        href="https://github.com/yoaquim"
                        target="_blank"
                        rel="noreferrer"
                        className="flex items-center gap-2 border border-line bg-panel px-3 py-1.5 text-body transition-colors duration-150 hover:border-accent hover:text-accent"
                    >
                        <svg className="w-4 h-4 text-accent" fill="currentColor" viewBox="0 0 24 24">
                            <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                        </svg>
                        github.com/yoaquim
                    </a>
                    <a
                        href="https://linkedin.com/in/yoaquim"
                        target="_blank"
                        rel="noreferrer"
                        className="flex items-center gap-2 border border-line bg-panel px-3 py-1.5 text-body transition-colors duration-150 hover:border-accent hover:text-accent"
                    >
                        <svg className="w-4 h-4 text-accent" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                        linkedin.com/in/yoaquim
                    </a>
                    <a
                        href="https://betabit.consulting"
                        target="_blank"
                        rel="noreferrer"
                        className="flex items-center gap-2 border border-line bg-panel px-3 py-1.5 text-body transition-colors duration-150 hover:border-accent hover:text-accent"
                    >
                        <svg className="w-4 h-4 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                        betabit.consulting
                    </a>
                    <span className="flex items-center gap-2 border border-line bg-well px-3 py-1.5 text-mute">
                        <svg className="w-4 h-4 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        SAN JUAN, PR
                    </span>
                </div>

                <div className="mt-4 flex justify-end">
                    <span className="font-mono text-[9.5px] tracking-[.2em] text-faint opacity-70">
                        YC//RES.01
                    </span>
                </div>
            </div>
        </header>
    )
}
